<template>
  <v-container>
    <v-card>
      <v-col>
        <v-select
          v-model="selectedSoftwareCode"
          :items="softwareList"
          label="Выберите интересующее ПО"
          :error="isButtonClicked && !selectedSoftwareCode"
          item-text="name"
          item-value="code"
        ></v-select>
        <v-card-text>Статистика версий указана за 3 дня.</v-card-text>
        <v-btn
          @click="getStatistics"
          :color="selectedSoftwareCode ? 'green' : 'grey'"
          dark
        >Сформировать</v-btn>
      </v-col>
    </v-card>
    <v-card>
      <v-col v-if="showTable">
        <v-data-table
          :headers="tableHeaders"
          :items="statisticsData"
          :page.sync="pagination.page"
          :items-per-page="pagination.itemsPerPage"
          dense
          class="elevation-1"
          no-data-text="Нет данных для создания таблицы"
          item-key="version"
        >
          <template v-slot:[`item.detail`]="{ item }">
            <v-tooltip top nudge-bottom="4">
              <template v-slot:activator="{ on, attrs }">
                <router-link
                  :to="`/versionStatistics/${selectedSoftwareCode}/${item.version}`"
                  ><v-icon v-bind="attrs" v-on="on"
                    >mdi-magnify</v-icon
                  ></router-link
                >
              </template>
              <span>Подробнее</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedSoftwareCode: null,
      isButtonClicked: false,
      tableHeaders: [
        { text: "Версия ПО", value: "version" },
        { text: "Количество объектов", value: "objectCounts" },
        { text: "Подробнее", value: "detail" },
      ],
      showTable: false,
      pagination: {
        page: 1,
        itemsPerPage: 10,
      },
    };
  },
  watch: {
    selectedSoftwareName: {
      handler() {
        this.selectedSoftware = this.selectedSoftwareName !== null;
      },
    },
  },
  async created() {
    await this.createSoftwareData();
  },
  computed: {
    ...mapGetters(["getStatisticsData", "softwareData"]),
    statisticsData() {
      return Object.entries(this.getStatisticsData)
        .sort((a, b) => b[1] - a[1])
        .map(([version, objectCounts]) => ({ version, objectCounts }));
    },
    softwareList() {
      return Object.entries(this.softwareData).map(([code, name]) => ({
        code: parseInt(code),
        name,
      }));
    },
  },
  methods: {
    ...mapActions(["fetchStatisticsData", "createSoftwareData"]),
    getStatistics() {
      this.isButtonClicked = true;
      if (this.selectedSoftwareCode !== null) {
        console.log("Selected Software Code:", this.selectedSoftwareCode);
        this.fetchStatisticsData({ softwareCode: this.selectedSoftwareCode });
        this.showTable = true;
      }
    },
  },
};
</script>
